"use strict";

import { useCallback } from 'react';
import { useFlixApiContext } from '../FlixApiContext';
import { removeFromFestivalWatchlistQuery } from './useFestivalWatchlistQuery';
export var useFestivalWatchlistRemoveMutation = function useFestivalWatchlistRemoveMutation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onCompleted = _ref.onCompleted,
      onError = _ref.onError;

  var _useFlixApiContext = useFlixApiContext(),
      client = _useFlixApiContext.client,
      flixApiV2 = _useFlixApiContext.flixApiV2;

  return [useCallback(function (film) {
    return flixApiV2('delete', "festival/".concat(film.festivalId, "/watch-list/").concat(film.id)).then(function () {
      removeFromFestivalWatchlistQuery(client, film.festivalId, film.slug);
      onCompleted && onCompleted();
    }).catch(function (error) {
      return onError ? onError(error) : Promise.reject(error);
    });
  }, [client, flixApiV2, onCompleted, onError])];
};